import type { WorkflowItem } from "@/api/models"
import type { Edge, Node } from "@xyflow/react"

import { normalizeWorkflowEdges } from "./workflow-edge-utils"

type WorkflowPersistenceMetadata = {
  title: string
  visibility: WorkflowItem["visibility"]
  defaultProjectId?: string | null
}

/**
 * Serialize only durable workflow definition fields. React Flow and the test
 * runner add selection, drag, measurement, and active-node state at runtime;
 * those fields must neither arm dirty detection nor leak into saved content.
 */
export function serializeWorkflowGraph(nodes: Node[], edges: Edge[]): string {
  const durableNodes = nodes.map((node) => {
    const durable = { ...node, data: { ...node.data } }
    delete durable.measured
    delete durable.selected
    delete durable.dragging
    delete (durable.data as Record<string, unknown>).active
    return durable
  })
  const durableEdges = normalizeWorkflowEdges(edges).map((edge) => {
    const durable = { ...edge }
    delete durable.selected
    return durable
  })
  return JSON.stringify({ nodes: durableNodes, edges: durableEdges })
}

export function serializeWorkflowMetadata({
  title,
  visibility,
  defaultProjectId,
}: WorkflowPersistenceMetadata): string {
  return JSON.stringify({
    title,
    visibility,
    default_project_id: defaultProjectId ?? null,
  })
}
